const ENOrgChart = {
	"Acumulado dos Itens do milestone deve totalizar": "Accumulated milestone items must total",
	"Adicionar Milestone": "Add Milestone",
	"Adicionar OKR": "Add OKR",
	"Adicionar Resultado Chave": "Add Key Result",
	"Alterar OKR": "Change OKR",
	"Alterar Resultado Chave": "Change Key Result",
	"Aperte no botão acima para adicionar": "Press the button above to add",
	"Após salvar o Resultados Chave, será liberado a opção para 'Listar Iniciativas' onde você poderá adicionar/editar as iniciativas deste Resultado Chave.": "After saving the Key Results, the option to 'List Initiatives' will be released where you can add/edit the initiatives of this Key Result.",
	"Ano atual": "Current year",
	"Check In adicionado com sucesso": "Check In successfully added",
	"Check In excluído com sucesso": "Check In successfully deleted",
	"Deseja realmente excluir o Check In": "Do you really want to delete the Check In",
	"Deseja realmente excluir o OKR": "Do you really want to delete the OKR",
	"Deseja realmente excluir o Resultado Chave": "Do you really want to delete the Key Result",
	"Desfocar desse card e mostrar seus irmãos": "Unfocus this card and show your brothers",
	"Digite o título do OKR para excluí-lo": "Enter OKR title to delete it",
	"É necessario preencher ao menos um item de milestone": "You must complete at least one milestone item",
	"É necessario preencher ao menos um indicador": "You must complete at least one indicator",
	"É necessario preencher ao menos um milestone": "You must complete at least one milestone",
	"É necessario preencher ao menos um projeto": "You must complete at least one project",
	"Equipe": "Team",
	"Erro ao adicionar OKR": "Error adding OKR",
	"Erro ao adicionar Resultado Chave": "Error adding key result",
	"Erro ao alterar OKR" : "Error changing OKR",
	"Erro ao alterar Resultado Chave" : "Error changing key result",
	"Erro ao atualizar número de anexos, favor atualizar a pagina": "Error updating number of attachments, please update page",
	"Erro ao atualizar número de comentários, favor atualizar a pagina": "Error updating number of comments, please update page",
	"Erro ao buscar informações de missão e premissas do OKR": "Error looking for OKR mission information and assumptions",
	"Erro ao buscar valor do check in": "Error fetching the check in value",
	"Erro ao excluir OKR": "Error deleting OKR",
	"Erro ao inserir Check In": "Error entering Check In",
	"Erro ao selecionar Milestones": "Error selecting Milestones",
	"Erro ao selecionar Resultado Chave": "Error selecting key result",
	"Erro ao selecionar OKR": "Error selection OKR",
	"Excluir Check In": "Delete Check In",
	"Exclusão de Check In": "Delete Check In",
	"Exclusão de OKR": "Delete OKR",
	"Exclusão de Resultado Chave": "Key Result Delete",
	"Existem Check In(s) em atraso, no dia de hoje ou próximo do dia": "There are Check In(s) overdue, today or close to the day",
	"Expandir OKRs Filhos": "Expand OKRs Children",
	"Focar nesse card e ocultar seus irmãos": "Focus on this card and hide your brothers",
	"Forma de Medição": "Measurement Method",
	"Forma de medição": "Measurement method",
	"Indicador é requerido": "Indicator is required",
	"Indicadores não podem ser repetidos": "Indicators cannot be repeated",
	"Individual": "Individual",
	"Listar iniciativas": "List iniciatives",
	"Listar OKR's": "List OKR'S",
	"Meta é requerido": "Goal is required",
	"Missão e Premissa": "Mission and Premise",
	"Missão e Premissas": "Mission and Assumptions",
	"Nenhum indicador adicionado": "No indicator added",
	"Nenhum milestone adicionado": "No milestone added",
	"Nenhum projeto adicionado": "No project added",
	"Nível da hierarquia": "Hierarchy level",
	"Não há nenhum Check In realizado": "There is no Check In performed",
	"Novo OKR": "New OKR",
	"Novo Resultado Chave": "New Key Result",
	"Ocultar OKRs Filhos": "Hide OKRs Children",
	"OKR adicionado com sucesso": "OKR successfully added",
	"OKR alterado com sucesso": "OKR successfully changed",
	"OKR excluído com sucesso": "OKR deleted successfully",
	"OKR Filho": "OKR Children",
	"Organizacional": "Organizational",
	"Os resultados chave são utilizados para preencher os percentuais no okr": "Key results are used to fill the percentages in okr",
	"Projeto é requerido": "Project is required",
	"Projetos não podem ser repetidos": "Projects cannot be repeated",
	"Próximo ano": "Next year",
	"Realizar Check In": "Check In",
	"Resultado Chave": "Key Result",
	"Resultados Chave": "Key Results",
	"Resultado Chave adicionado com sucesso": "Key result successfully added",
	"Resultado Chave alterado com sucesso" : "Key result successfully changed",
	"Resultado chave excluído com sucesso" : "Key result successfully deleted",
	"Tipo de Medição": "Measurement Type",
	"Tipo de medição": "Measurement type",
	"Titulo do OKR não confere": "OKR title does not match",
	"Valor inicial é requerido": "Initial value is required",
	"Visualizar hierarquia": "View hierarchy",
	"Visualizar Resultados Chave": "Visualize Key Result",
	"Você já concluiu todos os milestones": "You have completed all milestones",
	"Você pode adicionar/editar os milestones desse key result na tab de milestone.": "You can add/edit the milestones of this key result in the milestone tab."
};

export default ENOrgChart;
